import * as service from './ResetPassword.service.js'

export default {

  data() {

    return {
      ResetError: '',
      emaildisabled: true,
      Ispasswordok: false,
      Resetsucess: '',
      code: '',
      errorCount: '',
      errorStat: '',
      forgotMessage: '',
      testIn: '',
      testIn1: '',
      login: true,
      forgotPass: false,
      passClicked: false,
      passClickedConfirm: false,
      message1: '',
      EmailAddress: '',
      isdisablebutton: true,
      ResetForm: {

        NewPassword: '',
        ConfirmPassword: ''
      },
    }
  },


  mounted() {

    this.EmailAddress = (this.$route) ? this.$route.query.Username : '';
    this.code = (this.$route) ? this.$route.query.code : '';

  },

  methods: {
    submitForm(formName) {
      let context = this
      context.ResetError = ''
      context.Resetsucess = ''

      this.$refs[formName].validate((valid) => {

        if (valid) {
          loader.startLoader()
          let passresetdata = {
            Code: (this.code == '') ? '' : encodeURIComponent(this.code),
            Username: this.EmailAddress,
            NewPassword: this.ResetForm.NewPassword,
            ConfirmPassword: this.ResetForm.ConfirmPassword
          }

          if (this.code == '') {

            delete passresetdata['Code'];

            service.ForceResetPassword(passresetdata).then(function (response) {

              loader.stopLoader()
              $('.alert').show()
              context.Resetsucess = " Your password has been reset. You will be  automatically redirected to the login page. If not redirected, please click";
              setTimeout(function () {

                context.$router.push('/login')
              }, 5000);

            }, (error) => {

              context.ResetError = error.responseJSON.Message;
              loader.stopLoader()
              //this.isdisablebutton= true;

            })
          } else {
            service.ResetPassword(passresetdata).then(function (response) {

              loader.stopLoader()
              $('.alert').show()
              context.Resetsucess = " Your password has been reset. You will be  automatically redirected to the login page. If not redirected, please click";
              setTimeout(function () {

                context.$router.push('/login')

              }, 5000);

            }, (error) => {

              context.ResetError = error.responseJSON.Message;
              loader.stopLoader()
              //this.isdisablebutton= true;

            })
          }


        } else {
          this.$notify({

            title: 'Error',

            message: 'RESET PW - error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },


    togglePassword() {

      if (!this.passClicked) {
        $('#password').children().attr('type', 'text')
        this.passClicked = true
      } else {
        $('#password').children().attr('type', 'password')
        this.passClicked = false
      }
    },
    togglePasswordConfirm() {;
      if (!this.passClickedConfirm) {
        $('#passwordconfirm').children().attr('type', 'text')
        this.passClickedConfirm = true
      } else {
        $('#passwordconfirm').children().attr('type', 'password')
        this.passClickedConfirm = false
      }

    },

    backLogin() {
      this.$router.push('/login')
    },
    alertClose() {
      $('.alert').hide()
    },

  },
  watch: {

    ResetForm: {
      handler: function (newValue) {
        if (newValue.NewPassword.length >= 8 && newValue.NewPassword.match(/[!@#$%^&*(){}[\]<>?/|.:;_-]/) && newValue.NewPassword.match(/^(?=.*[A-Z])/) && newValue.NewPassword == newValue.ConfirmPassword) {

          this.isdisablebutton = false;
        } else {
          this.isdisablebutton = true;
        }
        if (newValue.NewPassword.length >= 8 && newValue.NewPassword.match(/[!@#$%^&*(){}[\]<>?/|.:;_-]/) && newValue.NewPassword.match(/^(?=.*[A-Z])/)) {

          this.Ispasswordok = false;
        } else {
          this.Ispasswordok = true;
        }
      },
      deep: true
    }

  }

}



// WEBPACK FOOTER //
// ./src/pages/ResetPassword/ResetPassword.controller.js